import React, { useEffect, useState, useContext } from "react";
import CollapseComponent from '../../components/Schedule/CollapseComponent';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, TextField, Chip,
  MenuItem, Box, Grid, Paper
} from '@mui/material';
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from '@mui/material/AccordionDetails';
import Accordion from '@mui/material/Accordion';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import Hitlist from "./Hitlist";
import Modal from 'react-bootstrap/Modal';
import ApiService from "../../functions/apiService";
import { useSnackbar } from 'notistack';
import moment from 'moment/moment';
import CustomSelect from "../../components/Schedule/CustomSelect";
import { useSelector } from 'react-redux';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { toast } from 'react-toastify';
import OrderList from "./OrderList";
import { varFormatTime } from "../../utils/helperFunctions";
import AuthContext from "../../context/AuthContext";
import { Row, Col } from "react-bootstrap";


const ToggleComponent = (props) => {
  const { showDay, newData, reformatColumns, onRowSelectionModelChange, SelectedEmp, expandAll,
    handleExpandChange, permission, onOpenModal, anyExpanded, data, handleRightClick, emptyCounts,
    emptyPositionColumns, date, loadData, is_dn_deparment, accordionDate, pages, isNightShift, mode2 , enableMultiSelect={enableMultiSelect} } = props
	const { user , v3Data } = useContext(AuthContext);
  // const { enqueueSnackbar } = useSnackbar();
  const AbsentReasonAll = useSelector((state) => state.dashboardReducer.AbsentReasonAll)
  let PossitionListDDL = useSelector((state) => state.ddlReducer.PossitionListDDL)
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [selectedName, setSelectedName] = useState('');
  const [isNight, setIsNight] = useState(false)
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [accorData, setAccorData] = useState([]);
  const [selectedComment, setSelectedComment] = useState('');
  const [rtoModal, setRtoModal] = useState(false)
  const [selectedShift, setSelectedShift] = useState('')
  const [newOvertime, setNewOvertime] = useState('')
  const [dcData, setDcData] = useState([]);
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const [selectedData, setSelectedData] = useState('');
  const [sortOrder, setSortOrder] = useState("asc");
  const [employee, setEmployee] = useState([]);
  const [posData, setPosData] = useState([]);
  const [position, setPosition] = useState([]);
  const currentDate = data.date;
  const [selectedempName, setSelectedempName] = useState('');
  const [onDutyCert, setOnDutyCert] = useState([]);
  const [status, setStatus] = useState('regular');
  const [delPtoModal, setDelPtoModal] = useState(false)
  const [deletePto, setDeletePto] = useState({})

  const handleShow = (comment) => {
    setSelectedComment(comment);
    setShow(true);
  };

  const handleOpen = (name) => {
    setSelectedName(name);
    setOpen('selected');
  };

  const loadAccordionData = (dateInput = '', load = true) => {
    if (load == true) {
      setLoading(true)
    }
    let todayDate = dateInput;
    ApiService.get('/getScheduleOvertimeShifts?date=' + todayDate)
      .then(({ data }) => {
        setAccorData(data.data);
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
        toast.error("Error")
        // enqueueSnackbar('Error', { variant: 'error' });
      })
  }

  const editOvertime = () => {
    const params = {
      "ShiftNumber": [selectedShift.Shift_Number],
      "FillEmp": false,
      "status": selectedShift.Status,
      "type": newOvertime,
      "SelEmp": "",
      "Comment": "",
      "date": accordionDate
    }
    ApiService.post('/editEmployeesOvertime', params)
      .then(() => {
        setRtoModal(false)
        loadAccordionData(moment(accordionDate, 'YYYY-MM-DD').format('DD-MM-YYYY'), false)
      }).catch((e) => {
        console.log(e)
      })
  }


   const deletePTO = () => {
    //deleteEmployeesOvertime?ShiftNumber[]=7&FillEmp=false&type=SPEEXT&date=2025-05-22
    ApiService.delete(`/deleteEmployeesOvertime?ShiftNumber[]=${deletePto?.Shift_Number}&FillEmp=false&date=${deletePto?.Shift_Date}`)
      .then((res) => {
        loadAccordionData(moment(accordionDate, 'YYYY-MM-DD').format('DD-MM-YYYY'), false)
        setDelPtoModal(false)
        setDeletePto({})
      }).catch((err) => {
        setDelPtoModal(false)
        console.log(err)
      })
  }
  
  const loadDCData = () => {
    let code = mode2 === 'night' ? 3 : 2;
    ApiService.get(`/get-schedule-certificate-employees?Shift_Code=${code}&Shift_Date=${moment(currentDate).format('YYYY-MM-DD')}`)
      .then(({ data }) => {
        setLoading(false);
        setDcData(data.data);
      })
      .catch((error) => {
        setLoading(false)
        toast.error("Error")
        // enqueueSnackbar('Error', { variant: 'error' });
      })
  }

  const loadOnDutyCertificate = () => {
    let code = mode2 === 'night' ? 3 : 2;
    ApiService.get(`/schedule-certificate-on-duty-employees?Shift_Code=${code}&Shift_Date=${moment(currentDate).format('YYYY-MM-DD')}`)
      .then(({ data }) => {
        setLoading(false);
        setOnDutyCert(data.data)
      })
      .catch((error) => {
        setLoading(false)
        toast.error("Error")
        // enqueueSnackbar('Error', { variant: 'error' });
      })
  }

  useEffect(() => {
		if(pages && pages.includes('V3_CERTIFICATE_MODULE')){
			loadDCData();
    	loadOnDutyCertificate();
		}
  }, [isNightShift , currentDate]);

  useEffect(() => {
    if (accordionDate) {
      loadAccordionData(moment(accordionDate, 'YYYY-MM-DD').format('DD-MM-YYYY'), false)
    }
  }, [accordionDate])

  const handleSort = () => {
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  let getPositionDropdown = () => {
    if (selectedEmployee) {
      let code = mode2 === 'night' ? 3 : 2;
      ApiService.get(`/getHitlistEmployeesPositions/${selectedEmployee}?date=${moment(currentDate).format('YYYY-MM-DD')}&shiftCode=${code}&status=${status}`)
        .then((data) => {
          setPosData(data?.data?.data)
        })
        .catch(() => {
        })
    }
  }

  useEffect(() => {
    if (selectedEmployee && selectedEmployee.length > 0) {
      getPositionDropdown();
    }
  }, [selectedEmployee])

  const handleChange = (event) => {
    setPosition(event.target.value);
  };

  let onSubmitAssign = () => {
    const req = {
      "ShiftNumber": [position.Shift_Number],
      "FillEmp": selectedData,
      "status": 'F',
      "type": position.Absent_Code,
      "SelEmp": "",
      "date": moment(currentDate).format('YYYY-MM-DD')
    }
    ApiService.post('/editEmployeesOvertime', req)
      .then((res) => {
        loadData(moment(currentDate).format('DD-MM-YYYY'))
        setOpen(false)
        // if (status === 'onDuty') {
        //   onSubmit()
        // }
      }).catch((err) => {
        console.log(err)
      })
  }

  let onSubmit = () => {
    let shiftCode = 3;
    let startTime = '';
    let endTime = '';

    if (position?.Shift_Code === 91) {
      if (position?.Start_Time >= '08:00:00' && position?.Start_Time <= '17:59:59') {
        shiftCode = 91;
        startTime = position?.Start_Time;
        endTime = position?.End_Time;
      } else {
        shiftCode = 91;
        startTime = position?.Start_Time;
        endTime = position?.End_Time;
      }
    }
    else {
      shiftCode = position?.Shift_Code == 2 ? 2 : 3;
      startTime = position?.Shift_Code == 3 ? '18:00:00' : '08:00:00';
      endTime = position?.Shift_Code == 3 ? '07:59:59' : '17:59:59';
    }

    ApiService.post('/postAdminAddOvertime', {
      "EmpCode": selectedData,
      "RequestDate": moment(currentDate).format('YYYY-MM-DD'),
      "ShiftCode": shiftCode,
      "SelAbsent": "REASSIGN",
      "StartTime": startTime,
      "EndTime": endTime,
      "SelEmp": '',
      "Comment": ''
    }).then(() => {
      loadData(moment(currentDate).format('DD-MM-YYYY'))
    }).catch((error) => {
      toast.error(error?.data?.message);
    });
  };


  const checkboxSelectionEnabled = (permission?.includes('Emp_Auth') && (v3Data?.V3_DEFAULT_MULTI_CHECKBOX_SCHEDULE ? enableMultiSelect : true)) ? true : false;
  const safeSelectionModel = checkboxSelectionEnabled ? SelectedEmp : (SelectedEmp?.slice(0, 1) ?? []);

  return (
    <div onContextMenu={handleRightClick}
      style={{
        borderBottom: '1px solid #cccccc',
        marginTop: '10px',
      }}
      className="station-section"
      >
      <Grid container>
        <Grid item xs={9} sx={{
          pr: 1,
        }}>
          <Box>
            {emptyCounts.length > 0 &&
              <div className="empty-position">
                <CollapseComponent
                  fontChanges={true}
                  rows={emptyCounts}
                  columns={emptyPositionColumns()}
                  name={'Empty Positions'}
                  checkboxSelection={false}
                  // open={expandAll}
                  open={false}
                  onExpandChange={handleExpandChange}
                  is_dn_deparment={is_dn_deparment}
                />
              </div>
            }
            {!isNightShift && showDay && newData && newData.dayEmployee &&
              Object.values(newData.dayEmployee).map((station) => (
                <CollapseComponent
                  fontChanges={true}
                  key={station.name}
                  rows={station.employees}
                  columns={reformatColumns(station.notAbsentDay, station.totalDay , station.minStaffDay	)}
                  name={station.name}
                  onRowSelectionModelChange={onRowSelectionModelChange}
                  rowSelectionModel={safeSelectionModel}
                  open={expandAll}
                  onExpandChange={handleExpandChange}
                  checkboxSelection={checkboxSelectionEnabled}
                  onOpenModal={onOpenModal}
                  showHeader={false}
                  is_dn_deparment={is_dn_deparment}
                  mode2={mode2}
                  page = {'schedule-page'}
                  minimumDayStaff = {station.minStaffDay}
                  isNightShift={isNightShift}
                />
              ))
            }
            {newData && newData.stations &&
              Object.values(newData.stations).map((station) => (
                <CollapseComponent
                  fontChanges={true}
                  key={station.name}
                  rows={station.employees}
                  columns={reformatColumns(station.notAbsentDay, station.totalDay, station.notAbsentNight, station.totalNight, isNightShift ? false : true , station.minStaffDay,  station.minStaffNight)}
                  name={station.name}
                  onRowSelectionModelChange={onRowSelectionModelChange}
                  rowSelectionModel={safeSelectionModel}
                  open={Object.keys(newData.stations).length < 1 ? true : false || expandAll}
                  minHeightRow='auto'
                  onExpandChange={handleExpandChange}
                  checkboxSelection={checkboxSelectionEnabled}
                  onOpenModal={onOpenModal}
                  showHeader={false}
                  is_dn_deparment={is_dn_deparment}
                  mode2={mode2}
                  page = {'schedule-page'}
                  minimumDayStaff = {station.minStaffDay}
                  minimumNightStaff = {station.minStaffNight}
                  isNightShift={isNightShift}
                />
              ))}
          </Box>
        </Grid>
        {data?.stations?.length > 0 &&
          <Grid item xs={3}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              marginTop: '8px',
            }}>
              <Accordion
                sx={{
                  '&.MuiAccordion-root': {
                    margin: '0px !important',
                    boxShadow: 'none !important'
                  },
                  '& .MuiButtonBase-root': {
                    backgroundColor: '#BF1D2D',
                    minHeight: '42px !important',
                    color: '#fff',
                    boxShadow: 'none !important'
                  },
                  '& .MuiAccordionSummary-content': {
                    margin: '0px !important',
                  },
                  '& .MuiAccordionSummary-expandIconWrapper': {
                    color: '#fff'
                  },
                  '& .MuiAccordionDetails-root': {
                    padding: '0px !important'
                  },
                }}>
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Typography component="span">Schedule</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box sx={{
                    boxShadow: '1px 1px 5px rgba(0, 0, 0, 0.5)', overflow: 'auto', msOverflowStyle: 'none',
                    scrollbarWidth: 'none',
                  }}>
                    <TableContainer>
                      {(v3Data?.V3_UPDATED_SIDEBAR_POSITION_PATTERN) && (v3Data?.V3_UPDATED_SIDEBAR_POSITION_PATTERN == '1' || v3Data?.V3_UPDATED_SIDEBAR_POSITION_PATTERN == 'true') ?
                        <Table sx={{ maxWidth: "100%" }} aria-label="transposed table">
                          <TableHead sx={{ backgroundColor: "#F4F4F4" }}>
                            <TableRow>
                              <TableCell>Field</TableCell>
                              {data && data.shifts &&
                                Object.values(data.shifts).map((shift, i) => (
                                  <TableCell key={i} align="left">{`${shift.Shift}`}</TableCell>
                                ))
                              }
                            </TableRow>
                          </TableHead>
                          <TableBody>

                            <TableRow>
                              <TableCell component="th" scope="row">Officers</TableCell>
                              {data && data.shifts &&
                                Object.values(data.shifts).map((shift, i) => (
                                  <TableCell key={i} align="left"><Typography color={shift.assignedOfficers >= shift.minimumOfficers ? 'black' : '#BF1D2D'}>{`${shift.assignedOfficers} / ${shift.minimumOfficers}`}</Typography></TableCell>
                                ))
                              }
                            </TableRow>

                            <TableRow>
                              <TableCell component="th" scope="row">Drivers</TableCell>
                                {data && data.shifts &&
                                  Object.values(data.shifts).map((shift, i) => (
                                    <TableCell key={i} align="left">
                                      <Typography color={shift.assignedDriver >= shift.minimumDriver ? 'black' : '#BF1D2D'}>
                                        {`${shift.assignedDriver} / ${shift.minimumDriver}`}
                                      </Typography>
                                    </TableCell>
                                  ))
                                }
                              </TableRow>

                            {Object.values(data?.shifts)?.filter((a) => a?.minimumMedics)?.length > 0 && (
                              <TableRow>
                                <TableCell component="th" scope="row">Medics</TableCell>
                                {data && data.shifts &&
                                  Object.values(data.shifts).map((shift, i) => (
                                    <TableCell key={i} align="left"><Typography color={shift.assignedMedics >= shift.minimumMedics ? 'black' : '#BF1D2D'}>
                                      {`${shift.assignedMedics} / ${shift.minimumMedics}`}
                                    </Typography></TableCell>
                                  ))
                                }
                              </TableRow>
                            )}

                          </TableBody>
                        </Table>
                        :
                        <Table sx={{ maxWidth: "100%" }} aria-label="transposed table">
                          <TableHead sx={{ backgroundColor: "#F4F4F4" }}>
                            <TableRow>
                              <TableCell>Field</TableCell>
                              {data && data.shifts &&
                                Object.values(data.shifts).map((shift, i) => (
                                  <TableCell key={i} align="left">{shift.Shift}</TableCell>
                                ))
                              }
                            </TableRow>
                          </TableHead>
                          <TableBody>

                            <TableRow>
                              <TableCell component="th" scope="row">Assigned</TableCell>
                              {data && data.shifts &&
                                Object.values(data.shifts).map((shift, i) => (
                                  <TableCell key={i} align="left">{shift.assigned}</TableCell>
                                ))
                              }
                            </TableRow>

                            {Object.values(data?.shifts)?.filter((a) => a?.filled)?.length > 0 && (
                              <TableRow>
                                <TableCell component="th" scope="row">Filled</TableCell>
                                {data && data.shifts &&
                                  Object.values(data.shifts).map((shift, i) => (
                                    <TableCell key={i} align="left">{shift.filled}</TableCell>
                                  ))
                                }
                              </TableRow>
                            )}

                            {data && data.datAbsentKeys && Object.values(data.datAbsentKeys).map((absentKey, i) => (
                              <TableRow key={i}>
                                <TableCell component="th" scope="row">{absentKey}</TableCell>
                                {data && data.shifts &&
                                  Object.values(data.shifts).map((shift, j) => (
                                    <TableCell key={j} align="left">
                                      {shift.employeeHasOvertimeShifts && Object.entries(shift.employeeHasOvertimeShifts)?.find(i => i[0] === absentKey)
                                        ? Object.entries(shift.employeeHasOvertimeShifts)?.find(i => i[0] === absentKey)[1]
                                        : ' '}
                                    </TableCell>
                                  ))
                                }
                              </TableRow>
                            ))}

                            {Object.values(data?.shifts)?.filter((a) => a?.minimumMedics)?.length > 0 && (
                              <TableRow>
                                <TableCell component="th" scope="row">Medics</TableCell>
                                {data && data.shifts &&
                                  Object.values(data.shifts).map((shift, i) => (
                                    <TableCell key={i} align="left"><Typography color={shift.assignedMedics >= shift.minimumMedics ? 'black' : '#BF1D2D'}>{shift.assignedMedics}</Typography></TableCell>
                                  ))
                                }
                              </TableRow>
                            )}

                            <TableRow>
                              <TableCell component="th" scope="row">Officers</TableCell>
                              {data && data.shifts &&
                                Object.values(data.shifts).map((shift, i) => (
                                  // <TableCell key={i} align="left">{shift.assignedOfficers}</TableCell>
                                  <TableCell key={i} align="left"><Typography color={shift.assignedOfficers >= shift.minimumOfficers ? 'black' : '#BF1D2D'}>{shift.assignedOfficers}</Typography></TableCell>
                                ))
                              }
                            </TableRow>

                            <TableRow>
                              <TableCell component="th" scope="row">Firefighters</TableCell>
                              {data && data.shifts &&
                                Object.values(data.shifts).map((shift, i) => (
                                  <TableCell key={i} align="left"><Typography color={((shift.allEmployeesCount - shift.assignedOfficers) >= (shift.minStaff - shift.minimumOfficers)) ? 'black' : '#BF1D2D'}>{shift.allEmployeesCount - shift.assignedOfficers}</Typography></TableCell>
                                ))
                              }
                            </TableRow>

                            <TableRow>
                              <TableCell component="th" scope="row">Total</TableCell>
                              {data && data.shifts &&
                                Object.values(data.shifts).map((shift, i) => (
                                  <TableCell key={i} align="left">
                                    <Typography color={shift.allEmployeesCount >= shift.minStaff ? 'green' : '#BF1D2D'}>
                                      {shift.allEmployeesCount}
                                    </Typography>
                                  </TableCell>
                                ))
                              }
                            </TableRow>
                          </TableBody>
                        </Table> 
                       }
                      
                    </TableContainer>
                  </Box>
                </AccordionDetails>
              </Accordion>

              {pages && pages.includes('V3_SIDEBAR_ORDERED_LIST') &&
                <OrderList />
              }

              {accorData.length === 0 ? '' : (
                <Accordion
                  sx={{
                    '&.MuiAccordion-root': {
                      margin: '0px !important',
                      boxShadow: 'none !important'
                    },
                    '&.MuiAccordion-root::before': {
                      display: 'none !important'
                    },
                    '& .MuiButtonBase-root': {
                      backgroundColor: '#BF1D2D',
                      minHeight: '42px !important',
                      color: '#fff',
                    },
                    '& .MuiAccordionSummary-content': {
                      margin: '0px !important',
                    },
                    '& .MuiAccordionSummary-expandIconWrapper': {
                      color: '#fff',
                    },
                    '& .MuiAccordionDetails-root': {
                      padding: '0px !important',
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ArrowDropDownIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                  >
                    <Typography component="span">{v3Data?.V3_PTO_REQUEST_NAME_IN_SCHEDULE ? v3Data?.V3_PTO_REQUEST_NAME_IN_SCHEDULE : "PTO Requests"}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box sx={{
                      boxShadow: '1px 1px 5px rgba(0, 0, 0, 0.5)', overflow: 'auto', msOverflowStyle: 'none',
                      scrollbarWidth: 'none',
                    }}>
                      <TableContainer>
                        <Table sx={{ maxWidth: "100%" }} aria-label="transposed table">
                          {accorData.map((data) => (
                            <TableBody
                              sx={{ backgroundColor: data?.Overtime_List === 'DAY' ? 'rgba(252, 199, 55, 0.1)' : 'rgba(216, 195, 233, 0.1)' }}>
                              <TableCell>{data?.orig_emp?.fullName}</TableCell>
                              <TableCell>

                                <div style={{
                                  padding: '2px 10px',
                                  backgroundColor: data?.Status === 'O' ? 'rgb(230, 39, 25)' : data?.Status === 'D' ? 'black' : 'orange',
                                  color: data?.Status === 'O' ? '#ffffff' : data?.Status === 'D' ? '#ffffff' : '#000000',
                                  cursor: 'pointer',
                                  fontSize: '10px',
                                  borderRadius: 50,
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }} onClick={() => {
                                  setRtoModal(true)
                                  setSelectedShift(data)
                                }}>
                                  {data?.Absent_Code}
                                  <ArrowDropDownIcon />
                                </div>
                              </TableCell>
                              <TableCell align="right">
                                <img
                                  src={data?.Shift_Code === 2 ? '/images/day.svg' : '/images/night.svg'}
                                  height={data?.Shift_Code === 2 ? '20px' : '16px'}
                                  width={data?.Shift_Code === 2 ? '20px' : '16px'}
                                />
                              </TableCell>

                              <TableCell align="right">
                                {data?.Comment === '' ? (
                                  <img
                                    height="16px"
                                    width="16px"
                                    style={{ display: 'none' }}
                                  />
                                ) : (
                                  <img
                                    src='/images/comment-schedule.svg'
                                    height="16px"
                                    width="16px"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleShow(data.Comment)}
                                  />
                                )}
                              </TableCell>
                              {permission?.includes('Emp_Auth') &&
                               <TableCell className="p-2">
                                <img src='/images/delete.svg' style={{ cursor: 'pointer', height: 20 }}
                                  onClick={() => {
                                    setDelPtoModal(true)
                                    setDeletePto(data)
                                  }} />
                              </TableCell>}
                            </TableBody>
                          ))}
                        </Table>
                      </TableContainer>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              )}

              {permission && permission.includes('Emp_Auth') && pages && pages.includes('V3_HITLIST_ASSIGNMENTS') &&
                <Accordion defaultExpanded
                  sx={{
                    '&.MuiAccordion-root': {
                      margin: '0px !important',
                      boxShadow: 'none !important'
                    },
                    '&.MuiAccordion-root::before': {
                      display: 'none !important'
                    },
                    '& .MuiButtonBase-root': {
                      backgroundColor: '#BF1D2D',
                      minHeight: '42px !important',
                      color: '#fff',
                    },
                    '& .MuiAccordionSummary-content': {
                      margin: '0px !important',
                    },
                    '& .MuiAccordionSummary-expandIconWrapper': {
                      color: '#fff',
                    },
                    '& .MuiAccordionDetails-root': {
                      padding: '0px !important',
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ArrowDropDownIcon />}
                    aria-controls="panel3-content"
                    id="panel3-header"
                  >
                    <Typography component="span">Quick Assignments</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <TableContainer component={Paper} sx={{
                      '& .MuiTableCell-root': {
                        padding: '10px 20px'
                      }
                    }}>
                      <Table aria-label="simple table">
                        <TableBody
                          onClick={() => {
                            handleOpen('Day hit list');
                            setIsNight(false);
                          }}
                          style={{ cursor: 'pointer' }}
                        >
                          <TableCell>Day hit list</TableCell>
                          <TableCell align="right">
                            <img
                              src="/images/right-arrow.svg"
                              style={{ cursor: 'pointer' }}
                            />
                          </TableCell>
                        </TableBody>

                        <TableBody
                          onClick={() => {
                            handleOpen('Night hit list');
                            setIsNight(true);
                          }}
                          style={{ cursor: 'pointer', backgroundColor: 'rgba(204, 204, 204, 0.2)' }}
                        >
                          <TableCell>Night hit list</TableCell>
                          <TableCell align="right">
                            <img
                              src="/images/right-arrow.svg"
                              style={{ cursor: 'pointer' }}
                            />
                          </TableCell>
                        </TableBody>
                        {/* <TableBody>
                        <TableCell>Acting LT</TableCell>
                        <TableCell align="right">
                          <img src="/images/right-arrow.svg" style={{ cursor: 'pointer' }} onClick={() => handleOpen('Acting LT')} />
                        </TableCell>
                      </TableBody>
                      <TableBody sx={{ backgroundColor: 'rgba(204, 204, 204, 0.2)' }}>
                        <TableCell>Acting Cpt</TableCell>
                        <TableCell align="right">
                          <img src="/images/right-arrow.svg" style={{ cursor: 'pointer' }} onClick={() => handleOpen('Acting Cpt')} />
                        </TableCell>
                      </TableBody>
                      <TableBody>
                        <TableCell>Acting DC</TableCell>
                        <TableCell align="right">
                          <img src="/images/right-arrow.svg" style={{ cursor: 'pointer' }} onClick={() => handleOpen('Acting DC')} />
                        </TableCell>
                      </TableBody> */}
                      </Table>
                    </TableContainer>
                  </AccordionDetails>
                </Accordion>
              }

              {onDutyCert.map((data, index) => {
                const sortedEmployees = [...data.certificate_employees].sort((a, b) => {
                  const hoursA = a?.Hours || 0;
                  const hoursB = b?.Hours || 0;
                  return sortOrder === "asc" ? hoursA - hoursB : hoursB - hoursA;
                });

                return (
                  <Accordion key={index}
                    sx={{
                      '&.MuiAccordion-root': {
                        margin: '0px !important',
                        boxShadow: 'none !important'
                      },
                      '&.MuiAccordion-root::before': {
                        display: 'none !important'
                      },
                      '& .MuiButtonBase-root': {
                        backgroundColor: '#BF1D2D',
                        minHeight: '42px !important',
                        color: '#fff',
                      },
                      '& .MuiAccordionSummary-content': {
                        margin: '0px !important',
                      },
                      '& .MuiAccordionSummary-expandIconWrapper': {
                        color: '#fff',
                      },
                      '& .MuiAccordionDetails-root': {
                        padding: '0px !important',
                      },
                    }}
                  >
                    <AccordionSummary expandIcon={<ArrowDropDownIcon />} aria-controls="panel2-content" id="panel2-header">
                      <Typography component="span">{data.Name}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box sx={{ boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.5)", overflow: "auto" }}>
                        <TableContainer>
                          <Table sx={{ maxWidth: "100%" }} aria-label="transposed table">
                            <TableHead sx={{ backgroundColor: "#F4F4F4" }}>
                              <TableRow>
                                <TableCell>Field</TableCell>
                                <TableCell onClick={handleSort} style={{ cursor: "pointer", display: "flex", alignItems: "center" }}>
                                  Hours
                                  {sortOrder === "asc" ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />}
                                </TableCell>
                                <TableCell></TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {sortedEmployees.map((value, idx) => (
                                <TableRow key={idx}>
                                  <TableCell>{value?.employee?.employee_assignment?.EA_Rank + ' ' + value?.employee?.fullName}</TableCell>
                                  <TableCell>{value?.Hours || 0}</TableCell>
                                  <TableCell align="right">
                                    <img
                                      src="/images/quick-assign.svg"
                                      height="24px" width="24px"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        handleShow2();
                                        setStatus('onDuty');
                                        setSelectedEmployee([value.employee.Emp_Code])
                                        setSelectedData(value.employee.Emp_Code)
                                        setSelectedempName(value.employee.employee_assignment.EA_Rank + ' ' + value.employee.fullName)
                                      }}
                                      alt="Quick Assign"
                                    />
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                );
              })}


              {dcData.map((data, index) => {
                const sortedEmployees = [...data.certificate_employees].sort((a, b) => {
                  const hoursA = a?.Hours || 0;
                  const hoursB = b?.Hours || 0;
                  return sortOrder === "asc" ? hoursA - hoursB : hoursB - hoursA;
                });

                return (
                  <Accordion key={index}
                    sx={{
                      '&.MuiAccordion-root': {
                        margin: '0px !important',
                        boxShadow: 'none !important'
                      },
                      '&.MuiAccordion-root::before': {
                        display: 'none !important'
                      },
                      '& .MuiButtonBase-root': {
                        backgroundColor: '#BF1D2D',
                        minHeight: '42px !important',
                        color: '#fff',
                      },
                      '& .MuiAccordionSummary-content': {
                        margin: '0px !important',
                      },
                      '& .MuiAccordionSummary-expandIconWrapper': {
                        color: '#fff',
                      },
                      '& .MuiAccordionDetails-root': {
                        padding: '0px !important',
                      },
                    }}
                  >
                    <AccordionSummary expandIcon={<ArrowDropDownIcon />} aria-controls="panel2-content" id="panel2-header">
                      <Typography component="span">{data.Name}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box sx={{ boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.5)", overflow: "auto" }}>
                        <TableContainer>
                          <Table sx={{ maxWidth: "100%" }} aria-label="transposed table">
                            <TableHead sx={{ backgroundColor: "#F4F4F4" }}>
                              <TableRow>
                                <TableCell>Field</TableCell>
                                <TableCell onClick={handleSort} style={{ cursor: "pointer", display: "flex", alignItems: "center" }}>
                                  Hours
                                  {sortOrder === "asc" ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />}
                                </TableCell>
                                <TableCell></TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {sortedEmployees.map((value, idx) => (
                                <TableRow key={idx}>
                                  <TableCell>{value?.employee?.employee_assignment?.EA_Rank + ' ' + value?.employee?.fullName}</TableCell>
                                  <TableCell>{value?.Hours || 0}</TableCell>
                                  <TableCell align="right">
                                    <img
                                      src="/images/quick-assign.svg"
                                      height="24px" width="24px"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        handleShow2();
                                        setStatus('regular');
                                        setSelectedEmployee([value.employee.Emp_Code])
                                        setSelectedData(value.employee.Emp_Code)
                                        setSelectedempName(value.employee.employee_assignment.EA_Rank + ' ' + value.employee.fullName)
                                      }}
                                      alt="Quick Assign"
                                    />
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                );
              })}

            </div>
          </Grid>
        }
      </Grid>
      <div>
        {open &&
          <Hitlist date={currentDate} open={open} setOpen={setOpen} selectedName={selectedName} loadData={loadData}
            setSelectedName={setSelectedName} isNight={isNight} setIsNight={setIsNight} />
        }
      </div>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Comment</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pb-4">{selectedComment || 'No Comment Available'}</Modal.Body>
      </Modal>

      <Modal show={show2} onHide={handleClose2}>
        <Modal.Body>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
            <Typography id="modal-modal-title" sx={{ fontSize: '18px', fontWeight: '700' }}>
              {selectedempName}
            </Typography>
            <img src='/images/close-icon.svg' style={{ cursor: 'pointer' }}
              onClick={() => {
                handleClose2();
                setSelectedEmployee([]);
                setSelectedempName('');
              }}
            />
          </div>
          <label className='my-1' style={{ fontSize: '14px' }}>Open Positions</label>
          {posData &&
            <TextField
              className='mt-0 w-100' color='secondary' variant="outlined"
              select
              size='small'
              label="Positions"
              InputProps={{
                sx: {
                  height: '48px',
                  fontSize: '14px'
                }
              }}
              InputLabelProps={{
                sx: {
                  marginTop: '3px',
                  fontSize: '14px'
                },
              }}
              onChange={handleChange}
            >
              <MenuItem value='' >Please Select </MenuItem>
              {posData?.map((option) => (
                <MenuItem value={option} key={option}>
                  <div>
                    <span>{option?.employee_assignment?.position?.SO_Desc || `Detail${option?.Detail_Text ? ` [${option.Detail_Text.split(' ').slice(0,5).join(' ')}${option.Detail_Text.split(' ').length > 5 ? '...' : ''}]` : ''}`}</span>
                    <span>
											{option?.Shift_Code === 2 ? ' (Day)' : option?.Shift_Code === 3 ? ' (Night)' : ` (Custom ${varFormatTime(`${option?.Start_Time}-${option?.End_Time}`, user?.Time_Format)})`}
                    </span>
                  </div>
                </MenuItem>
              ))}

            </TextField>
          }
          <ButtonTheme type='submit' variant="filled" color='primary' className='px-5 mt-4'
            onClick={() => {
              onSubmitAssign();
              handleClose2();
            }}
          >
            Save
          </ButtonTheme>
        </Modal.Body>
      </Modal>

      <Modal show={rtoModal}>
        <Modal.Body>
          <div className="w-100 d-flex justify-content-end">
            <img src='/images/close-icon.svg' style={{ cursor: 'pointer' }} onClick={() => setRtoModal(false)} />
          </div>
          <label className='my-1' style={{ fontSize: '14px' }}>Reason</label>
          {AbsentReasonAll &&
            <TextField
              className='mt-0 w-100' color='secondary' variant="outlined"
              select
              size='small'
              label="Reason"
              InputProps={{
                sx: {
                  height: '48px',
                  fontSize: '14px'
                }
              }}
              InputLabelProps={{
                sx: {
                  marginTop: '3px',
                  fontSize: '14px'
                },
              }}
            >
              <MenuItem value='' >Please Select </MenuItem>
              {Object.entries(AbsentReasonAll)?.map((option) => (
                <MenuItem value={option[0]} key={option[0]} onClick={() => setNewOvertime(option[0])}>
                  {option[1]}
                </MenuItem>
              ))}
            </TextField>
          }
          <ButtonTheme type='submit' variant="filled" color='primary' className='px-5 mt-4' disabled={!permission?.includes('Emp_Auth')}
            onClick={editOvertime}>
            Save
          </ButtonTheme>
        </Modal.Body>
      </Modal>


       <Modal show={delPtoModal} onHide={() => setDelPtoModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Delete PTO</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ color: '#555555' }}>
            Are you sure to delete this PTO?
          </div>
          <Row>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setDelPtoModal(false)}>
                Cancel
              </ButtonTheme>
            </Col>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={deletePTO}>
                Delete
              </ButtonTheme>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default ToggleComponent;